import 'babel-polyfill'
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import * as VueGoogleMaps from 'vue2-google-maps'
import Vue from 'vue';
import './plugins/axios';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from '@/store';
import './registerServiceWorker';
import ViewHeader from '@/components/ViewHeader.vue';
import VueApexCharts from 'vue-apexcharts';
import VueSweetalert2 from 'vue-sweetalert2';
import GenericView from './views/GenericView'
import DriverHub from './plugins/driverhub'

import 'sweetalert2/dist/sweetalert2.min.css';
import '@/style/print.css'

Vue.config.productionTip = false;

Vue.component('view-header',ViewHeader);
Vue.component('apexchart', VueApexCharts);
Vue.component('generic-view', GenericView);
 
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA9qXb7TInG7XwY7kBatpz8p_oK1xe5hko',
    libraries: 'places,drawing,visualization', // This is required if you use the Autocomplete plugin
    fields: ['opening_hours','utc_offset_minutes'],
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
 
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
 
  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,
 
  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
})

Vue.filter("truncate", function (text, length, separator) {
  if (!text) return text;

  if (text.length > length) {
    return (
      text.substring(0, length) +
      separator +
      text.substring(text.length - length, text.length)
    );
  }

  return text;
});

Vue.use(VueSweetalert2)
Vue.use(DriverHub, store)

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
